// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lastMonthWinners_cup__WbNgZ {\n  cursor: pointer;\n}\n\n.lastMonthWinners_list__q-Ht0 {\n  position: relative;\n  min-width: 100px;\n  min-height: 100px;\n}\n.lastMonthWinners_list__q-Ht0 ol {\n  margin-left: 2rem;\n}", ""]);
// Exports
exports.locals = {
	"cup": "lastMonthWinners_cup__WbNgZ",
	"list": "lastMonthWinners_list__q-Ht0"
};
module.exports = exports;
